import Tabs from "@common/Tabs";
import Tab from "@common/Tab";
import DynamicContent from "../../../nav/DynamicContent";
import {Assessment, Assignment, List} from "@mui/icons-material";
import DiagnosticReports from "../../../diagnosticReporting/DiagnosticReports";
import React from "react";

const PrePostTestTabs = (props) => {
    return (<Tabs id={'diagnosticPrePostTabs'} defaultActiveKey={0} variant="standard">
            <Tab id={'diagnosticPreTest'}
                 children={<DynamicContent url={'/controlCentre/showGroupTests.action'} params={{testGroupCode: 'DIAGNOSTIC_PRE_TEST', testSearchType: 'TEST_GROUP', tabIndex: 0}}/>}
                 tab={
                    <>
                        <List className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>Pre {props.diagnosticNameLower}</span>
                    </>
                } key={0}/>
            <Tab id={'diagnosticPostTest'}
                 children={<DynamicContent url={'/controlCentre/showGroupTests.action'} params={{testGroupCode: 'DIAGNOSTIC_POST_TEST', testSearchType: 'TEST_GROUP', tabIndex: 1}}/>}
                 tab={
                    <>
                        <List className={'margin-r--m'}/>
                        <span className={'margin-r--m tabText'}>Post {props.diagnosticNameLower}</span>
                    </>
                } key={1}/>
            <Tab id={'diagnosticTestAssignments'}
                 children={<DynamicContent url={'/controlCentre/showTestAssignment.action'} params={{diagnosticTest: true}}/>}
                 tab={
                     <>
                         <Assignment className={'margin-r--m'}/>
                         <span className={'margin-r--m tabText'}>Assigned</span>
                     </>
                 } key={2}/>
            <Tab id={'diagnosticReports'}
                 children={<DiagnosticReports style={{overflowX: 'none'}}/>}
                 tab={
                     <>
                         <Assessment className={'margin-r--m'}/>
                         <span className={'margin-r--m tabText'}>Reports</span>
                     </>
                 } key={3}/>
        </Tabs>
    )
}
export default PrePostTestTabs;
